import * as React from 'react'
import { useCallback } from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { editMatchedLocationHeader } from './constants'
import { AddLeadHeaderContainer } from '@sales-center/components'
import Typography from '@mui/material/Typography'
import { useGetLocationUrl } from '@user/store/authorization/hooks'
import LaunchIcon from '@mui/icons-material/Launch'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'

type Props = {
  externalLocationId: string
  isBillTo: boolean
}

export function EditMatchedLocationHeaderAddLead(props: Props) {
  const { externalLocationId, isBillTo } = props
  const locationUrl = useGetLocationUrl(externalLocationId, isBillTo)

  const openLocation = useCallback(() => {
    window.open(locationUrl, '_blank')
  }, [locationUrl])
  const theme = useTheme()
  return (
    <AddLeadHeaderContainer
      flexDirection="row"
      alignItems={'center'}
      justifyContent="space-between"
      gap={10}
    >
      <Stack direction="row">
        <InfoOutlined
          sx={{
            color: '#0288d1',
            fontSize: '22px',
            marginRight: theme.spacing(1.5),
          }}
        />
        <Typography
          sx={{
            color: '#013654',
            letterSpacing: '0.17px',
            lineHeight: '23px',
          }}
        >
          {editMatchedLocationHeader}
        </Typography>
      </Stack>
      <Box>
        <Button
          color="primary"
          variant="text"
          size="small"
          onClick={openLocation}
          sx={{
            textTransform: 'none',
            fontWeight: 'bold',
          }}
          data-test-id="edit-in-pestpac"
        >
          Edit In PestPac
          <LaunchIcon
            sx={{
              marginLeft: theme.spacing(1),
              fontSize: '18px',
            }}
          />
        </Button>
      </Box>
    </AddLeadHeaderContainer>
  )
}
